export const machineTypeOptions = [
  { value: "fundacja_orchidea", label: "Fundacja Orchidea" },
  { value: "default", label: "Default Machine" },
];

/**
 * Fallback configuration for Fundacja Orchidea machine type.
 * 
 * NOTE: Channel order should be derived from API response (source file order).
 * This config is only used as a fallback for legacy sessions that don't have
 * persisted channel order, or for band configuration.
 * 
 * @deprecated channels - Use dynamic order from API response
 */
export const fundacjaOrchideaDisplayConfig = {
  // DEPRECATED: Use API response order instead for channel ordering.
  // This list is kept for backward compatibility with legacy sessions.
  channels: [
    "Fp1",
    "Fp2",
    "F7",
    "F3",
    "Fz",
    "F4",
    "F8",
    "T3",
    "C3",
    "Cz",
    "C4",
    "T4",
    "T5",
    "P3",
    "Pz",
    "P4",
    "T6",
    "O1",
    "O2",
  ],
  // Bands are still used from config (consistent across all files)
  bands: ["delta", "theta", "alpha", "smr", "beta", "beta2"],
};

// For future reference: expected channel count may vary depending on source file
export const EXPECTED_CHANNEL_COUNTS = [13, 18, 19, 21]; // Common configurations

export const getDeviationCellColor = (zScoreValue) => {
  // console.log({
  //   zScoreValue,
  // });
  // if (zScoreValue === null || zScoreValue === undefined || isNaN(zScoreValue))
  //   return "#ffffff";

  // const intensity = Math.min(Math.abs(zScoreValue) / 2.5, 1);
  // let r, g, b;

  // if (zScoreValue > 0.25) {
  //   r = 255;
  //   const greenBlueBase = 220;
  //   g = greenBlueBase - Math.floor(120 * intensity);
  //   b = greenBlueBase - Math.floor(120 * intensity);
  // } else if (zScoreValue < -0.25) {
  //   b = 255;
  //   const redGreenBase = 220;
  //   r = redGreenBase - Math.floor(120 * intensity);
  //   g = redGreenBase - Math.floor(120 * intensity);
  // } else {
  //   return "#f8f8f8";
  // }
  // return `rgb(${Math.max(0, Math.min(255, r))}, ${Math.max(
  //   0,
  //   Math.min(255, g)
  // )}, ${Math.max(0, Math.min(255, b))})`;
  return "#f8f8f8";
};
